import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialTable, { MTableToolbar } from 'material-table';

class BOPInstitutions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:[],
      columns: [
        // { title: 'ID', field: 'id' },
        { title: 'Description', field: 'description' },
      ],
    };
  }

  componentDidMount() {
    var params = {
      'tablename': this.props.bopinstitutions.tablename
    }
    this.props.getBOPInstitutions(params);
  }

  render() {
    // console.log ( '4444-5882 - ReferralAddContainer - state = ', this.state);
    // console.log ( '4444-5883 - ReferralAddContainer - ownProps = ', this.props);

    return (
      <div style={{ maxWidth: '100%' }}>
          <MaterialTable
            title="BOP institutions"
            columns={this.state.columns}
            data={this.props.bopinstitutions.bopinstitutions}

            options={{
              // search
              search: true,
              // header grouping
              // grouping: true,
              // or              
              // column filtering
              // filtering: true,
              
              // pagination settings
              // show paging buttons
              // paging:false,
              // default items per page
              pageSize:75,
              // paging options
              pageSizeOptions:[25,50,75,100],

              // ???
              // columnsButton:false,
              // move buttons to right side of list
              // actionsColumnIndex: -1, 

              // styling otions
              rowStyle:{height:"20px"},
              maxBodyHeight: 700,
              
              // CSV export
              // exportButton: true,
              // default filename
              exportFileName: 'CPCMexport-BOPInstitutions',
              // comma delimited
              // exportDelimiter: ',', 

            }}











/////////////////////
          //   // edit button to left
          //   actions={[
          //     {
          //       icon: 'edit',
          //       tooltip: 'Edit Entry',
          //       onClick: (event, rowData) => {
          //         console.log('4444-901 - BOPInstitutions - MaterialTable - event = ', event);
          //         console.log('4444-902 - BOPInstitutions - MaterialTable - rowData = ', rowData);
                  
          //         alert('You Edited ' + rowData.id + ' ' + rowData.description)
                  
          //       },

          //       // save icon
          //       // icon: 'save',
          //       // tooltip: 'Save User',
          //       // onClick: (event, rowData) => {
          //       //   console.log('4444-901 - BOPInstitutions - MaterialTable - event = ', event);
          //       //   console.log('4444-902 - BOPInstitutions - MaterialTable - rowData = ', rowData);
          //       //   // Do save operation
          //       // }
          //     },
          // ]}
////////////////////////////////








          // custom Toolbar
          components={{
            Toolbar: props => (
              <div style={{
                background: 'linear-gradient(45deg, #f48fb1 10%, #fff 70%)', // blue / fade light blue
                color: 'white',
              }}>
                  <MTableToolbar {...props} />
              </div>
            )
          }}


          // add , update , and delete 
          editable={{
            onRowAdd: newData =>
              new Promise((resolve, reject) => {                
                var params = {
                  'description': newData.description
                  , 'tablename': this.props.bopinstitutions.tablename
                }
                this.props.addBOPINSTITUTION(params);              
                  // add to state
                  const data = this.state.data;
                  data.push(newData);
                  this.setState({ data }, () => resolve());                  
              }),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                var params = {
                  'description': newData.description
                  , 'tablename': this.props.bopinstitutions.tablename
                }
                this.props.updateBOPInstitution(newData.id,params);                 
                  // update the state
                  const data = this.state.data;
                  const index = data.indexOf(oldData);
                  data[index] = newData;
                  this.setState({ data }, () => resolve());
              }),
            // onRowDelete: oldData =>
            //   new Promise((resolve, reject) => {
            //     var params = {
            //       'tablename': this.props.bopinstitutions.tablename
            //     }
            //     this.props.deleteBOPInstitution(oldData.id,params);
            //       // remove from state
            //       let data = this.state.data;
            //       const index = data.indexOf(oldData);
            //       data.splice(index, 1);
            //       this.setState({ data }, () => resolve());
            //   }),
          }}














/////////////////////////////
        // // import CreateIcon from '@material-ui/icons/Create';
        // actions={[
        //   {
        //     icon: 'save',
        //     tooltip: 'Save User',
        //     onClick: (event, rowData) => alert("You saved " + rowData.name)
        //   }
        // ]}
        // components={{
        //   Action: props => (
        //     <Button
        //       onClick={(event) => props.action.onClick(event, props.data)}
        //       color="primary"
        //       variant="contained"
        //       style={{textTransform: 'none'}}
        //       size="small"
        //     >
        //       My Button
        //     </Button>
        //   ),
        // }}
////////////////








///////////////////////////

            // editable={{



              // onRowAdd: newData =>
              //   new Promise(resolve => {
              //     setTimeout(() => {
              //       resolve();
              //       // const data = [...this.state.data];
              //       const data = [...this.props.bopinstitutions];
              //       data.push(newData);
              //       this.setState({ ...this.state, data });
              //     }, 600);
              //   }),
              // onRowUpdate: (newData, oldData) =>
              //   new Promise(resolve => {
              //     setTimeout(() => {
              //       resolve();
              //       // const data = [...this.state.data];
              //       const data = [...this.props.bopinstitutions];
              //       data[data.indexOf(oldData)] = newData;
              //       this.setState({ ...this.state, data });
              //     }, 600);
              //   }),
              // onRowDelete: oldData =>
              //   new Promise(resolve => {
              //     setTimeout(() => {
              //       resolve();
              //       // const data = [...this.state.data];
              //       const data = [...this.props.bopinstitutions];
              //       data.splice(data.indexOf(oldData), 1);
              //       this.setState({ ...this.state, data });
              //     }, 600);
              //   }),



              // onRowAdd: newData =>
              //   new Promise(resolve => {
              //     setTimeout(() => {
              //       resolve();
              //       // const data = [...this.state.data];
              //       const data = [...this.props.bopinstitutions];
              //       data.push(newData);
              //       this.setState({ ...this.state, data });
              //     }, 600);
              //   }),
              // onRowUpdate: (newData, oldData) =>
              //   new Promise(resolve => {
              //     setTimeout(() => {
              //       resolve();
              //       // const data = [...this.state.data];
              //       const data = [...this.props.bopinstitutions];
              //       data[data.indexOf(oldData)] = newData;
              //       this.setState({ ...this.state, data });
              //     }, 600);
              //   }),
              // onRowDelete: oldData =>
              //   new Promise(resolve => {
              //     setTimeout(() => {
              //       resolve();
              //       // const data = [...this.state.data];
              //       const data = [...this.props.bopinstitutions];
              //       data.splice(data.indexOf(oldData), 1);
              //       this.setState({ ...this.state, data });
              //     }, 600);
              //   }),
///////////////////////////////////



            // }}
          />
      </div>
    );
  }
}

BOPInstitutions.propTypes = {
  className: PropTypes.string,
};

export default BOPInstitutions;






  
  // //////////////////
  // class RefreshData extends React.Component {
  //   constructor(props) {
  //     super(props);
  
  //     this.tableRef = React.createRef();
  //   }
    
  //   render() {
  //     return (
  //       <MaterialTable        
  //         title="Refresh Data Preview"
  //         tableRef={this.tableRef}
  //         columns={[
  //           {
  //             title: 'Avatar',
  //             field: 'avatar',
  //             render: rowData => (
  //               <img
  //                 style={{ height: 36, borderRadius: '50%' }}
  //                 src={rowData.avatar}
  //               />
  //             ),
  //           },
  //           { title: 'Id', field: 'id' },
  //           { title: 'First Name', field: 'first_name' },
  //           { title: 'Last Name', field: 'last_name' },
  //         ]}
  //         data={query =>
  //           new Promise((resolve, reject) => {
  //             let url = 'https://reqres.in/api/users?'
  //             url += 'per_page=' + query.pageSize
  //             url += '&page=' + (query.page + 1)
  //             fetch(url)
  //               .then(response => response.json())
  //               .then(result => {
  //                 resolve({
  //                   data: result.data,
  //                   page: result.page - 1,
  //                   totalCount: result.total,
  //                 })
  //               })
  //           })
  //         }
  //         actions={[
  //           {
  //             icon: 'refresh',
  //             tooltip: 'Refresh Data',
  //             isFreeAction: true,
  //             onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
  //           }
  //         ]}
  //       />
  //     )
  //   }
  // }
  // //////////////////////////////////
